module.exports = __webpack_public_path__ + "static/thunderplains18-8f15b2717e74791a9134affc067a6ed5.jpeg";